import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '@/router/constants'
import type { ImportWrapper } from '@/types'

export const getOppoWLRoutes = ({ registerImport }: { registerImport: ImportWrapper }) => {
    const routes: RouteRecordRaw[] = [
        {
            path: 'export/game/:game',
            name: ROUTE_NAMES.EXPORT_GAME_PAGE,
            component: registerImport(() => import('@/pages/Games/ExportGame.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: 'category/:categorySlug',
            name: ROUTE_NAMES.WHITE_LABEL_2PAGE_CATEGORY,
            component: registerImport(() => import('@/pages/WhiteLabel/TwoPageCategory.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: ':gameSlug/game.html',
            name: ROUTE_NAMES.WHITE_LABEL_2PAGE_LAUNCH,
            component: registerImport(() => import('@/pages/WhiteLabel/TwoPageLaunch.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: ':gameSlug/index.html',
            name: ROUTE_NAMES.WHITE_LABEL_2PAGE_GAME,
            component: registerImport(() => import('@/pages/WhiteLabel/TwoPageGame.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: 'about-us',
            name: ROUTE_NAMES.WHITE_LABEL_ABOUT_US,
            component: registerImport(() => import('@/pages/static/StaticPage.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: 'confidential',
            name: ROUTE_NAMES.WHITE_LABEL_CONFIDENTIAL,
            component: registerImport(() => import('@/pages/static/StaticPage.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: 'contacts',
            name: ROUTE_NAMES.WHITE_LABEL_CONTACTS,
            component: registerImport(() => import('@/pages/static/StaticPage.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: 'terms-of-use',
            name: ROUTE_NAMES.WHITE_LABEL_TERMS_OF_USE,
            component: registerImport(() => import('@/pages/static/StaticPage.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: '',
            name: ROUTE_NAMES.WHITE_LABEL_2PAGE,
            component: registerImport(() => import('@/pages/WhiteLabel/TwoPageCatalog.vue')),
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
        {
            path: 'error',
            component: {
                render: () => null,
            },
            meta: {
                noLocaleInRoute: true,
                noLayout: true,
            },
        },
    ]

    return routes
}
